<button (click)="openQuickPanel.emit()" class="button" fxFlex="grow" mat-button>
  <mat-icon>format_align_right</mat-icon>
</button>
